var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"list"}},[(_vm.show)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeEvent),expression:"closeEvent"}],ref:"dropdown",staticClass:"bly-popover",style:(_vm.styles),attrs:{"id":"dropdown"}},[_c('div',{staticClass:"menu"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }